import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooks"><Path fillRule="evenodd" clipRule="evenodd" d="M13.5 6.67175L18.3063 5.29357L22.4409 19.7125L17.6346 21.0907L13.5 6.67175Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 3V21H13.5V3H6.5ZM8 7H12V9H8V7ZM12 15H8V17H12V15Z" fill="currentColor"/><Path d="M2 5V21H5.5V5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooks;
